import styled from 'styled-components';

import {MOON_150} from '../../../../../../common/css/color.styles';

export const ValueViewPrimitive = styled.div`
  display: inline-block;
  padding: 0 4px;
  background-color: ${MOON_150};
  border-radius: 4px;
  font-weight: 600;
  font-family: monospace;
  font-size: 10px;
  line-height: 20px;
`;
ValueViewPrimitive.displayName = 'S.ValueViewPrimitive';
